import { Record } from 'immutable';

export const EfectorImportLog = new Record({
  isPending: false,
  data: null,
  error: null
});